// extracted by mini-css-extract-plugin
export default {"container":"Skeleton__container--lc-VqjHF","card":"Skeleton__card--lc-HpgI1"};